import React from 'react';
import './indproduct.scss';
import Parser from 'html-react-parser';
import { umoksType } from '../../types/types.js';
import { Link } from 'react-router-dom';

class IndProduct extends React.Component {
  constructor(props) {
    super(props);
  };
  getIdProd = () => {
    const { indproductList } = this.props;

    return indproductList && indproductList.map((item, i, arr) => {
      return (
        <div className='f-item f-item-4 f-center'>
          <Link to = {item.link}>
            <div className='company-propduct-item'>
              <img src={item.img} />
              <div className='propduct-title-wrap'>
                {Parser(item.content)}
              </div>
            </div>
          </Link>
        </div>
      );
    });
  };

  render() {
    return (
      <section className='company-propduct-wrap f-center'>
        <div className='f-container'>
          <div className='f-row'>
            {this.getIdProd()}
          </div>
        </div>
      </section>
    );
  };
};


IndProduct.propTypes = {
  indproductList:umoksType.isRequired
};

export default  IndProduct;



// WEBPACK FOOTER //
// ./src/client/components/indproduct/indproduct.jsx